import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const OfferAssetEquipmentsComponent = React.memo(({ equipments, t }) => {
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <Table>
          {equipments && equipments.length > 0 && (
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>{t('OfferEdit.Asset.Equipments.Name')}</strong>
                </TableCell>
                <TableCell>
                  <strong>{t('OfferEdit.Asset.Equipments.Type')}</strong>
                </TableCell>
                <TableCell>
                  <strong>{t('OfferEdit.Asset.Equipments.Price')}</strong>
                </TableCell>
              </TableRow>
            </TableHead>
          )}
          {equipments && equipments.length > 0 && (
            <TableBody>
              {equipments.map((item, idx) => {
                return (
                  <TableRow key={idx}>
                    <TableCell style={{ width: '50%' }}>{item.name}</TableCell>
                    <TableCell style={{ width: '40%' }}>{item.typeName}</TableCell>
                    <TableCell style={{ width: '10%' }}>{item.price}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          )}
        </Table>
      </Grid>
    </Grid>
  );
});

OfferAssetEquipmentsComponent.displayName = 'OfferAssetEquipmentsComponent';

OfferAssetEquipmentsComponent.propTypes = {
  equipments: PropTypes.array,
  t: PropTypes.func.isRequired
};

export default compose(withTranslation())(OfferAssetEquipmentsComponent);
